import Swiper, { Navigation, Pagination } from "swiper";

(function () {
    const widgets = document.querySelectorAll(".js-testimonials");
    widgets.forEach((widget) => {
        const testimonials = widget.querySelectorAll(".swiper-slide");

        if (testimonials.length === 1) return;

        const swiper = new Swiper(widget.querySelector(".swiper"), {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                clickable: true,
                el: widget.querySelector(".swiper-pagination"),
            },
            navigation: {
                nextEl: widget.querySelector(".swiper-navigation--next"),
                prevEl: widget.querySelector(".swiper-navigation--prev"),
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
            },
        });
    });
})();
